import { VenueIntegrationProduct } from '@models/venue/VenueIntegration'
import { useAppSelector } from '@store/hooks'
import { selectVenueById } from '@store/VenueReducer'
import { Space, Steps } from 'antd'
import { useState } from 'react'
import { APIKeySelection } from './steps/APIKeySelection'
import { AreaBookingVisibilities } from './steps/AreaBookingVisibilities'
import { SeatingAreasMappingSharedDisclaimer } from './steps/SeatingAreasMappingSharedDisclaimer'
import { SteatingAreasMapping } from './steps/SteatingAreasMapping'
import { TestIntegration } from './steps/TestIntegration'

interface SevenroomsConnectorConfigurationProps {
  venueId: number
  product: VenueIntegrationProduct
}

const SevenroomsConnectorConfiguration = ({
  venueId,
  product,
}: SevenroomsConnectorConfigurationProps) => {
  const venue = useAppSelector(selectVenueById(venueId))

  const [current, setCurrent] = useState<number>(0)

  if (!venue) return <></>

  const next = () => {
    setCurrent(current + 1)
  }

  const prev = () => {
    setCurrent(current - 1)
  }
  const steps = [
    {
      title: 'API Key',
      content: (
        <APIKeySelection venue={venue} product={product} onNext={next} />
      ),
    },
    ...(product === 'app'
      ? [
          {
            title: 'Areas mapping',
            content: (
              <SteatingAreasMapping
                venue={venue}
                product={product}
                onPrev={prev}
                onNext={next}
              />
            ),
          },
          {
            title: 'Booking visibilities',
            content: (
              <AreaBookingVisibilities
                venue={venue}
                product={product}
                onNext={next}
                onPrev={prev}
                onFinish={() => {}}
              />
            ),
          },
        ]
      : [
          {
            title: 'Areas mapping',
            content: (
              <SeatingAreasMappingSharedDisclaimer
                venue={venue}
                product={product}
                onNext={next}
                onPrev={prev}
                onFinish={() => {}}
              />
            ),
          },
        ]),
    {
      title: 'Test integration',
      content: (
        <TestIntegration
          venue={venue}
          product={product}
          onPrev={prev}
          onNext={next}
        />
      ),
    },
  ]

  return (
    <Space orientation="vertical" size={10} className="w-full">
      <Steps
        current={current}
        items={steps.map((step) => ({ ...step, content: undefined }))}
        type="navigation"
        onChange={(e) => setCurrent(e)}
      />
      {steps[current].content}
    </Space>
  )
}

export { SevenroomsConnectorConfiguration }
